<div *ngIf="isLoading" class="loading">
  <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
</div>

<h2 mat-dialog-title>{{title}} for {{filename}}</h2>
<mat-dialog-content>
 
  <ng-template ngFor let-error [ngForOf]="errors">
    <p>
      <span mat-line>{{ error }}</span>
    </p>
    <mat-divider></mat-divider>
  </ng-template>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="ok()">{{ 'close' | translate }}</button>
</mat-dialog-actions>